'use client';

import { c as _c } from "react/compiler-runtime";
import { formatFiatUnits } from '@morfi/onramp-sdk';
import type { FundingCheckout } from '@morfi/onramp-sdk/react';
import { useLocale, useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import { AnimatedButton } from '@/components/ui/animated-button';
import { useFormattedCurrency } from '@/lib/currency/use-formatted-currency';
import { FundingFees } from '../amount/funding-fees';
import { FundingCheckoutFeedback } from '../funding-checkout-feedback';
import { FundingLimitRecovery } from '../funding-limit-recovery';
import { FundingQuoteSummary } from './funding-quote-summary';
export function FundingHostedReview(t0) {
  const $ = _c(95);
  const {
    checkout
  } = t0;
  const t = useTranslations("onramp");
  const {
    formatD6
  } = useFormattedCurrency();
  const locale = useLocale();
  const {
    review,
    method
  } = checkout;
  if (!review || !method) {
    return null;
  }
  const {
    estimate
  } = review;
  const resumeWidget = Boolean(checkout.attemptId && checkout.paymentSignature && !checkout.transactionId);
  let t1;
  if ($[0] !== estimate.currency || $[1] !== estimate.decimals || $[2] !== locale) {
    t1 = units => formatFiatUnits(units, estimate.decimals, estimate.currency, locale);
    $[0] = estimate.currency;
    $[1] = estimate.decimals;
    $[2] = locale;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const money = t1;
  const t2 = estimate.targetUnits ?? estimate.principalUnits;
  let t3;
  if ($[4] !== money || $[5] !== t2) {
    t3 = money(t2);
    $[4] = money;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className="my-4 text-center text-display-sm">{t3}</div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("hosted_receive");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <dt className="text-foreground-secondary">{t5}</dt>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== estimate.principalUnits || $[14] !== estimate.receivedLocalUnits || $[15] !== formatD6 || $[16] !== method || $[17] !== money || $[18] !== review.receivedUnits) {
    t7 = method === "sepa" ? `~${formatD6(review.receivedUnits, "full")}` : money(estimate.receivedLocalUnits ?? estimate.principalUnits);
    $[13] = estimate.principalUnits;
    $[14] = estimate.receivedLocalUnits;
    $[15] = formatD6;
    $[16] = method;
    $[17] = money;
    $[18] = review.receivedUnits;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t7) {
    t8 = <dd className="text-right">{t7}</dd>;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t) {
    t9 = t("destination");
    $[22] = t;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t9) {
    t10 = <dt className="text-foreground-secondary">{t9}</dt>;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== checkout.operation?.destination || $[27] !== t) {
    t11 = checkout.operation?.destination ?? t("hosted_destination");
    $[26] = checkout.operation?.destination;
    $[27] = t;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11) {
    t12 = <dd className="break-all text-right">{t11}</dd>;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t) {
    t13 = t("hosted_payment_method");
    $[31] = t;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== t13) {
    t14 = <dt className="text-foreground-secondary">{t13}</dt>;
    $[33] = t13;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  let t15;
  if ($[35] !== method || $[36] !== t) {
    t15 = t(method);
    $[35] = method;
    $[36] = t;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== t15) {
    t16 = <dd className="text-right">{t15}</dd>;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t10 || $[41] !== t12 || $[42] !== t14 || $[43] !== t16 || $[44] !== t6 || $[45] !== t8) {
    t17 = <dl className="grid grid-cols-2 gap-y-3 text-caption md:text-body">{t6}{t8}{t10}{t12}{t14}{t16}</dl>;
    $[40] = t10;
    $[41] = t12;
    $[42] = t14;
    $[43] = t16;
    $[44] = t6;
    $[45] = t8;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== checkout) {
    t18 = <FundingQuoteSummary checkout={checkout} />;
    $[47] = checkout;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  const t19 = estimate.targetUnits ?? estimate.principalUnits;
  let t20;
  if ($[49] !== estimate || $[50] !== review.limits || $[51] !== t19) {
    t20 = <FundingFees currency={estimate.currency} decimals={estimate.decimals} principalUnits={t19} estimate={estimate} limits={review.limits} />;
    $[49] = estimate;
    $[50] = review.limits;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  let t21;
  if ($[53] !== t) {
    t21 = t("hosted_total");
    $[53] = t;
    $[54] = t21;
  } else {
    t21 = $[54];
  }
  let t22;
  if ($[55] !== t21) {
    t22 = <dt>{t21}</dt>;
    $[55] = t21;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== estimate.totalUnits || $[58] !== money) {
    t23 = money(estimate.totalUnits);
    $[57] = estimate.totalUnits;
    $[58] = money;
    $[59] = t23;
  } else {
    t23 = $[59];
  }
  let t24;
  if ($[60] !== t23) {
    t24 = <dd className="text-right font-medium">{t23}</dd>;
    $[60] = t23;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] !== t22 || $[63] !== t24) {
    t25 = <dl className="grid grid-cols-2 text-body">{t22}{t24}</dl>;
    $[62] = t22;
    $[63] = t24;
    $[64] = t25;
  } else {
    t25 = $[64];
  }
  let t26;
  if ($[65] !== method || $[66] !== t) {
    t26 = method === "sepa" ? t("bank_floating_disclosure") : t("hosted_disclosures");
    $[65] = method;
    $[66] = t;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  let t27;
  if ($[68] !== t26) {
    t27 = <p className="text-caption text-foreground-secondary">{t26}</p>;
    $[68] = t26;
    $[69] = t27;
  } else {
    t27 = $[69];
  }
  let t28;
  let t29;
  if ($[70] !== checkout) {
    t28 = <FundingCheckoutFeedback checkout={checkout} />;
    t29 = <FundingLimitRecovery checkout={checkout} />;
    $[70] = checkout;
    $[71] = t28;
    $[72] = t29;
  } else {
    t28 = $[71];
    t29 = $[72];
  }
  const t30 = checkout.busy || !checkout.attemptId && (review.state !== "ready" || Boolean(checkout.error));
  let t31;
  if ($[73] !== checkout || $[74] !== resumeWidget) {
    t31 = () => {
      if (checkout.attemptId && !resumeWidget) {
        checkout.viewPaymentStatus();
      } else {
        checkout.pay();
      }
    };
    $[73] = checkout;
    $[74] = resumeWidget;
    $[75] = t31;
  } else {
    t31 = $[75];
  }
  let t32;
  if ($[76] !== checkout.attemptId || $[77] !== resumeWidget || $[78] !== t) {
    t32 = checkout.attemptId && !resumeWidget ? t("hosted_view_status") : t("hosted_confirm");
    $[76] = checkout.attemptId;
    $[77] = resumeWidget;
    $[78] = t;
    $[79] = t32;
  } else {
    t32 = $[79];
  }
  let t33;
  if ($[80] !== checkout.busy || $[81] !== t30 || $[82] !== t31 || $[83] !== t32) {
    t33 = <AnimatedButton className="h-11 w-full" size="lg" loading={checkout.busy} disabled={t30} onClick={t31}>{t32}</AnimatedButton>;
    $[80] = checkout.busy;
    $[81] = t30;
    $[82] = t31;
    $[83] = t32;
    $[84] = t33;
  } else {
    t33 = $[84];
  }
  let t34;
  if ($[85] !== t17 || $[86] !== t18 || $[87] !== t20 || $[88] !== t25 || $[89] !== t27 || $[90] !== t28 || $[91] !== t29 || $[92] !== t33 || $[93] !== t4) {
    t34 = <div className="flex flex-col gap-4">{t4}{t17}{t18}{t20}{t25}{t27}{t28}{t29}{t33}</div>;
    $[85] = t17;
    $[86] = t18;
    $[87] = t20;
    $[88] = t25;
    $[89] = t27;
    $[90] = t28;
    $[91] = t29;
    $[92] = t33;
    $[93] = t4;
    $[94] = t34;
  } else {
    t34 = $[94];
  }
  return t34;
}